import * as Sentry from '@sentry/react';
import log from 'loglevel';

import { THEME_STORAGE_KEY } from '../context/ThemeContext';
import { ZustandStores } from '../store';

export const PERSISTED_STORE_NAMES = Object.values(ZustandStores);

const deleteDB = (dbName: string): Promise<void> =>
  new Promise((resolve, reject) => {
    const request = indexedDB.deleteDatabase(dbName);

    request.onsuccess = () => resolve();
    request.onerror = () => reject(request.error);
    request.onblocked = () => {
      const isKnownZustandDB = PERSISTED_STORE_NAMES.includes(
        dbName as ZustandStores,
      );
      if (!isKnownZustandDB) {
        const message = `Database ${dbName} is blocked and cannot be deleted`;
        log.error(message);
        Sentry.captureMessage(message, { level: 'error' });
      }
      resolve();
    };
  });

export const clearIndexedDB = async (): Promise<void> => {
  try {
    if ('databases' in indexedDB) {
      const databases = await indexedDB.databases();

      const dbNames = databases
        .map((db) => db.name)
        .filter((name): name is string => Boolean(name));

      await Promise.all(dbNames.map(deleteDB));
      return;
    }
    const fallbackDBs = ['zustand-storage', ...PERSISTED_STORE_NAMES];
    await Promise.all(fallbackDBs.map(deleteDB));
  } catch (error) {
    log.error('Error clearing IndexedDB', { error });
  }
};

export const clearAllStorages = () => {
  const persistedTheme = localStorage.getItem(THEME_STORAGE_KEY);
  localStorage.clear();
  if (persistedTheme !== null) {
    localStorage.setItem(THEME_STORAGE_KEY, persistedTheme);
  }
  sessionStorage.clear();
  document.cookie.split(';').forEach((c) => {
    document.cookie = c
      .replace(/^ +/, '')
      .replace(/=.*/, `=;expires=${new Date().toUTCString()};path=/`);
  });
};
